const isProduction = process.env.NODE_ENV === 'production';

//export const API_BASE_URL = isProduction
  //? 'https://merseapizzaandgroceries.co.uk:8443/api'
 // : 'https://localhost:8443';

export const API_BASE_URL ='https://merseafeastandgroceries.co.uk:8443';

//export const API_BASE_URL ='https://localhost:8443';